export const GOOGLE_MAPS_API_KEY = 'AIzaSyA7YwLuHjNLKRSzYbAo2FwH2iEeLoBn9BA';
